// extracted by mini-css-extract-plugin
export default {"dialog":"FileIdDialog_dialog__vQxoA","actionsRow":"FileIdDialog_actionsRow__RR03g"};